import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import AASignsLanding from './pages/AASignsLanding';
import SiteVisitRequest from './pages/SiteVisitRequest';

function App() {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<AASignsLanding />} />
          <Route path="/request-visit" element={<SiteVisitRequest />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;